import { useState } from 'preact/hooks';
import { Nav } from '../components/Nav';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Partners } from '../components/Partners';
import { StoreModal } from '../components/StoreModal';
import { Footer } from '../components/Footer';

export function Landing() {
  const [modal, setModal] = useState<{ open: boolean; store: string | null }>({
    open: false,
    store: null,
  });

  return (
    <>
      <Nav />
      <Hero onPour={() => setModal({ open: true, store: 'Waitlist' })} />
      <About />
      <Partners />
      <Footer />
      <StoreModal
        open={modal.open}
        storeName={modal.store}
        onClose={() => setModal({ open: false, store: null })}
      />
    </>
  );
}
